module.exports = __webpack_public_path__ + "assets/7b5e67df53a63b64e7e16ef6849f340e.mp3";